import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Transition } from 'react-transition-group';
import { Dropdown, DropdownMenu, transitionStyles } from './dropdownStyles';
import { connect } from 'react-redux';
import { setMunicipality } from 'filters/actions';
import { filterData } from 'filters/selectors';
import { getData, dataReceived, originalDocuments } from 'datahub/actions';
import dataService from 'api/dataService';
import { media } from 'components/styled/utils';
import { strings } from 'config';

import qs from 'qs';

class SimpleDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: 'सबै स्थानिय सरकारहरु',
      isOpen: false
    };

    this.munName = qs.parse(this.props.location.search)['?mun'];
  }

  componentDidMount() {
    const { items, handleFilters, filters } = this.props;
    if(items.length === 1){
      this.setState({
        selectedValue: items[0].title
      });

      const filteredResult = {
        ...filters,
        ...{
          page: 1,
          municipality: { id: items[0].mpc_id, name: items[0].title, nameEn: items[0].titleEn },
        }
      };
      handleFilters(filteredResult);

    }else if (this.munName) {
      if (items.filter(val => val.title === this.munName).length) {
        const { mpc_id: selectedMunId, titleEn } = items.filter(
          val => val.title === this.munName
        )[0];
        let selectedMun = { id: selectedMunId, name: this.munName, nameEn: titleEn };
        this.setState({
          selectedValue: this.munName
        });

        const filteredResult = {
          ...filters,
          ...{
            page: 1,
            municipality: selectedMun
          }
        };
        handleFilters(filteredResult);
      }
    }
  }

  handleDropdownMenu = dropdownState => {
    this.setState({
      isOpen: dropdownState
    });
  };

  componentWillReceiveProps() {
    const { filters } = this.props;
    const selectedLang = strings.getLanguage();

    const selectedValue =
      selectedLang === 'en' ? filters.municipality.nameEn : filters.municipality.name;

    // if (!this.munName) {
    this.setState({
      selectedValue: selectedValue
    });
    // }
  }

  handleChange = (dropdownValue, dropdownLabel, dropdownLabelEn) => {
    const { filters, handleFilters } = this.props;

    this.setState(
      {
        isOpen: false,
        selectedValue: dropdownLabel
      },
      () => {
        let selectedMun = { id: dropdownValue, name: dropdownLabel, nameEn: dropdownLabelEn };

        const filteredResult = {
          ...filters,
          ...{ municipality: selectedMun }
        };

        handleFilters(filteredResult);
        this.props.history.push('/');
      }
    );
  };

  render() {
    const { items } = this.props;
    const selectedLang = strings.getLanguage();

    return (
      <Dropdown
        onMouseEnter={() => this.handleDropdownMenu(true)}
        onMouseLeave={() => this.handleDropdownMenu(false)}
      >
        <DropdownButton isOpen={this.state.isOpen}>
          <Title className="title" isOpen={this.state.isOpen}>
            {this.state.selectedValue}
          </Title>
          {items.length !== 1 && <DropdownIcon isOpen={this.state.isOpen}/>}
        </DropdownButton>

        <Transition in={this.state.isOpen} timeout={100} mountOnEnter={true}>
          {state => (
            <DropdownMenu
              style={{
                ...transitionStyles[state]
              }}
            >
              <ul className="dropdown-list">
                {items.map((val, key) => (
                  <li
                    className="dropdown-list-item"
                    key={key}
                    onClick={() => this.handleChange(val.mpc_id, val.title, val.titleEn)}
                  >
                    {selectedLang === 'en' ? val.titleEn : val.title}
                  </li>
                ))}
              </ul>
            </DropdownMenu>
          )}
        </Transition>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    dataList: state.datahub.dataList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setMunicipality(filters.municipality));
      const queryParams = filterData(filters);
      dispatch(getData());
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
        dispatch(originalDocuments(response));
      });
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SimpleDropdown));

const DropdownButton = styled.span`
  position: relative;
  display: inline-block;
  background-color: #cbe1f4;
  border-radius: 2px;
  cursor: pointer;
  padding: 12px 16px;
  border-radius: 26px;
  transition: all 0.2s ease-in;
  text-align: center;
  min-width: 188px;
  background-color: ${props => (props.isOpen ? props.theme.teals.tilicho : '#46c0b8')};

  ${media.sm`
    padding: 18px 16px;
  `};
`;

const Title = styled.span`
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  font-weight: 600;
`;

const DropdownIcon = styled.span`
  border-color: ${props =>
    props.isOpen ? `transparent transparent #fff` : `#fff transparent transparent;`}
    border-width: ${props => (props.isOpen ? '0 4px 4px' : '4px 4px 0')};
  border-style: solid;
  display: inline-block;
  vertical-align: middle;
`;



// WEBPACK FOOTER //
// ./src/components/layouts/dropdowns/simpleDropdown.js